export default "__VITE_ASSET__Cl3$3Tu___"